import type { MessagingGetChatRooms200PageAllOfThreeContentItemParticipantsItemBasicInfo } from './messagingGetChatRooms200PageAllOfThreeContentItemParticipantsItemBasicInfo';
import type { MessagingGetChatRooms200PageAllOfThreeContentItemParticipantsItemSocial } from './messagingGetChatRooms200PageAllOfThreeContentItemParticipantsItemSocial';

/**
 * 간략한 사용자 정보
 */
export type MessagingGetChatRooms200PageAllOfThreeContentItemParticipantsItem = {
  /** 사용자 기본 정보 */
  basicInfo: MessagingGetChatRooms200PageAllOfThreeContentItemParticipantsItemBasicInfo;
  /** 소셜 관계 정보 */
  social?: MessagingGetChatRooms200PageAllOfThreeContentItemParticipantsItemSocial;
};
